import { render } from "./detail-grid-quotes.vue?vue&type=template&id=54b15588&ts=true"
import script from "./detail-grid-quotes.vue?vue&type=script&lang=ts"
export * from "./detail-grid-quotes.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__